import { createSlice } from 'utils/@reduxjs/toolkit';
import { reducers } from './reducers';
import { StockStatusState } from './types';

export const initialState: StockStatusState = {
  isLoading: false,
  data: {
    items: [],
  },
  error: null,
};

const slice = createSlice({
  name: 'stock',
  initialState,
  reducers,
});

export const { actions: stockActions } = slice;
export const { reducer: stockReducer } = slice;
